import React from 'react';
import ListStory from '../../components/ListStory/ListStory';

const JobStory = () => {
  return <ListStory page={1} type="jobstories" />;
};

export default JobStory;
